var $ = require( 'jquery' );

let clickEvent = '';
if ( 'ontouchstart' in window ) {
	clickEvent = 'touchstart';
} else {
	clickEvent = 'click tap';
}

$( document ).ready( function() {

});

$( 'window' ).on( 'load', function() {

});

$('img.hero-image').on('load', function() {

});

$( window ).resize( function() {

});